var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckboxDropdownMenu from '@/shared/components/input/CheckboxDropdownMenu';
import { Dropdown } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';
import { defineMessages, useIntl } from 'react-intl';
var messages = defineMessages({
    SelectYourFilters: {
        id: 'SelectYourFilters',
        defaultMessage: 'Select your filters',
    },
    MoreFilters: {
        id: 'MoreFilters',
        defaultMessage: 'More filters',
    },
});
export var DynamicFilterDropdown = function (_a) {
    var items = _a.items, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    if (!items || items.length <= 0)
        return null;
    return (_jsxs(Dropdown, __assign({ id: "dynamicFilterMenu" }, { children: [_jsxs(Dropdown.Toggle, __assign({ title: formatMessage(messages.SelectYourFilters) }, { children: [_jsx(FaFilter, { className: "react-icon margin5R" }), formatMessage(messages.MoreFilters)] })), _jsx(CheckboxDropdownMenu, { bsRole: "menu", items: items, onItemChanged: onChange })] })));
};
export default DynamicFilterDropdown;
